import { StaticBreadcrumbs } from "../StaticBreadcrumbs";
import StaticPageNavigation from "common/blocks/StaticPageNavigation";
import classNames from "classnames/bind";
import styles from "./StaticPageHeader.module.scss";
import { ResolvedStaticPageNavigation } from "resolvers/data/staticPageNavigation/pageNavigationResolver";

const cx = classNames.bind(styles);

export type StaticPageHeaderProps = {
    title: string;
    breadcrumbText: string;
    pageNavigation?: ResolvedStaticPageNavigation;
};

export default function StaticPageHeader(props: StaticPageHeaderProps) {
    return (
        <div className={cx("background")}>
            <div className={cx("breadcrumb-wrapper")}>
                <div className={cx("container")}>
                    <StaticBreadcrumbs {...props} />
                </div>
            </div>
            <div className={cx("title-wrapper")}>
                <h1 className={cx("title")}>
                    {!!props.title ? props.title : props.breadcrumbText}
                </h1>
            </div>
            {!!props.pageNavigation && (
                <StaticPageNavigation props={props.pageNavigation}></StaticPageNavigation>
            )}
        </div>
    );
}
